import Link from 'next/link'
import {
  getResearchAuthor,
  RESEARCH_METHODS_PATH,
  RESEARCH_TEAM_PATH,
} from '@dupe/common/research-report'

interface SeoReportAuthorProps {
  categorySlug: string | null | undefined
}

export function SeoReportAuthor({ categorySlug }: SeoReportAuthorProps) {
  const author = getResearchAuthor(categorySlug)

  return (
    <aside className='flex items-start gap-4'>
      {/* Byline avatar mirrors the hub-page byline (HubHero): the Dupe brand
          mark fills the circle. The byline is the organizational research
          team, never a portrait of a person who does not exist. */}
      <div className='flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-accent md:h-14 md:w-14'>
        {author.avatarUrl ? (
          <img
            src={author.avatarUrl}
            alt={author.name}
            className='h-12 w-12 object-cover md:h-14 md:w-14'
          />
        ) : (
          <span className='text-base font-semibold text-foreground-secondary'>
            {author.name.charAt(0)}
          </span>
        )}
      </div>
      <div className='flex min-w-0 flex-1 flex-col gap-0.5'>
        <p className='text-sm text-foreground'>
          By{' '}
          <Link
            href={RESEARCH_TEAM_PATH}
            className='font-semibold underline decoration-border underline-offset-4 transition-colors hover:decoration-foreground'
          >
            {author.name}
          </Link>
        </p>
        <p className='text-sm leading-5 text-foreground-secondary md:text-base md:leading-6'>
          {author.bio}{' '}
          <Link
            href={RESEARCH_METHODS_PATH}
            className='whitespace-nowrap font-medium text-foreground underline decoration-border underline-offset-4 transition-colors hover:decoration-foreground'
          >
            How we research
          </Link>
        </p>
      </div>
    </aside>
  )
}
